import assetPath from '/opt/actions-runner/_work/crate/crate/packages/login/layout/src/background-layout/images/hidden-jobs.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')